// breadcrumb.constants.ts

export const ONBOARDING_MAP: Record<string, string> = {
  '68511ccbc23e7a0f7ae563fa': 'My Compliances',
  '68511cebc23e7a0f7ae563fd': 'My Policies',
  '68511d73c23e7a0f7ae56405': 'Data Strategy',
  '68511d54c23e7a0f7ae563ff': 'Application Control',
  '68511dafc23e7a0f7ae56412': 'Infrastructure Management',
  '68511dc8c23e7a0f7ae56427': 'OT/ICS/DCS/SCADA',
  '68511e30c23e7a0f7ae5643d': 'Training Management',
};

export const LIBRARY_MAP: Record<string, string> = {
  'evidence-library': 'Evidence Library',
  //   'assets-library': 'Assets Library',
  'domain-library': 'Domain Library',
  'ssl-library': 'SSL Library',
  'policy-library': 'Policy Library',
};

export const WORK_MAP: Record<string, string> = {
  tasks: 'Tasks',
  'my-action-items': 'My Action Items',
  'actionables-list': 'Actionables',
};

export const SCC_MAP: Record<string, string> = {
  'executive-dashboard': 'Executive Dashboard',
  'posture-scorecard': 'Posture Scorecard',
  'compliance-heatmap': 'Compliance Heatmap',
  'risk-trends': 'Risk Trends',
};
export const WORKSPACE_MAP: Record<string, string> = {
  dashboard: 'My Dashboard',
  tasks: 'My Tasks',
  actionables: 'My Action Items',
  // 'my-assets': 'My Assets',
  bookmarks: 'My Bookmarks',
};
export const CONTROL_TASK_MAP: Record<string, string> = {
  'task-dashboard': 'Task Dashboard',
  tasks: 'All Tasks',
  'control-actions': 'Control Actions',
  activities: 'Recurring Activities',
  assets: 'Assets',
};
export const RISK_IMPACT_MAP: Record<string, string> = {
  'risk-dashboard': 'Risk Dashboard',
  'risk-register': 'Risk Register',
  'system-risk': 'System Risks',
  'business-impact-analysis': 'Business Impact Analysis',
  'risk-scenarios': 'Risk Scenarios / Simulations',
};
export const COMPLIANCE_MAP: Record<string, string> = {
  'compliance-dashboard': 'Compliance Dashboard',
  'active-frameworks': 'Active Frameworks',
  'framework-library': 'Framework Library',
  'framework-details': 'Framework Details',
  'policy-management': 'Policy Management',
  'evidence-vault': 'Evidence Vault',
};
export const DIGITAL_ASSET_MAP: Record<string, string> = {
  'asset-dashboard': 'Asset Dashboard',
  'asset-inventory': 'Asset Inventory',
  'patch-intelligence': 'Patch Intelligence',
  'asset-risk-mapping': 'Asset-Risk Mapping',
};
export const EXTERNAL_SURFACE_MAP: Record<string, string> = {
  'domain-inventory': 'Domain Inventory',
  'dns-ssl-monitoring': 'DNS & SSL Monitoring',
  'dmarc-security': 'DMARC / Email Security',
  'external-exposure-view': 'External Exposure View',
};
export const SECURITY_INTEGRATIONS_MAP: Record<string, string> = {
  'integration-marketplace': 'Integration Marketplace',
  'connected-systems': 'Connected Systems',
  'data-pipelines': 'Data Pipelines',
  'api-access': 'API Access',
  'security-landscape': 'Security Landscape',
};
export const VULNERABILITY_MAP: Record<string, string> = {
  'vulnerability-dashboard': 'Vulnerability Dashboard',
  'remediation-tracking': 'Remediation Tracking',
  'scanner-integrations': 'Scanner Integrations',
};
export const PRIVACY_MAP: Record<string, string> = {
  'privacy-dashboard': 'Privacy Dashboard',
  'consent-management': 'Consent Management',
  'data-mapping': 'Data Mapping',
  'dpia-risk-assessments': 'DPIA / Risk Assessments',
};
export const BREADCRUMB_SECTIONS = [
  {
    parent: 'Security Command Center',
    baseUrl: '/eciso/executive-dashboard',
    children: {
      'executive-dashboard': 'Executive Dashboard',
      'posture-scorecard': 'Posture Scorecard',
      'compliance-heatmap': 'Compliance Heatmap',
      'risk-trends': 'Risk Trends',
    },
  },
  {
    parent: 'My Workspace',
    baseUrl: '/eciso/dashboard',
    children: {
      dashboard: 'My Dashboard',
      tasks: 'My Tasks',
      'my-action-items': 'My Action Items',
      'actionables-list': 'My Action Items',
      // 'my-assets': 'My Assets',
      bookmarks: 'My Bookmarks',
    },
  },
  {
    parent: 'Control & Task Operations',
    baseUrl: '/eciso/task-dashboard',
    children: {
      'task-dashboard': 'Task Dashboard',
      tasks: 'All Tasks',
      'control-actions': 'Control Actions',
      activities: 'Recurring Activities',
      'all-action-items': 'All Action Items',
      'assets-list': 'Assets',
      'asset-details': 'Assets',
      'evidence-vault': 'Evidence Vault',
    },
  },
  {
    parent: 'Risk & Impact Management',
    baseUrl: '/eciso/risk-dashboard',
    children: {
      'risk-dashboard': 'Risk Dashboard',
      'business-impact-analysis': 'Business Impact Analysis',
      'risk-scenarios': 'Risk Scenarios / Simulations',
    },
  },
  {
    parent: 'Risk Register',
    baseUrl: '/eciso/risk-dashboard',
    children: {
      'risk-register': 'System Risks',
      'system-risk': 'System Risks',
      'manual-risk': 'Manual Risks',
    },
  },
  {
    parent: 'Compliance & Governance',
    baseUrl: '/eciso/compliance-dashboard',
    children: {
      'compliance-dashboard': 'Compliance Dashboard',
    },
  },
  {
    parent: 'Library',
    baseUrl: '/eciso/compliance-dashboard',
    children: {
      'framework-library': 'Framework Library',
      'policy-management': 'Policy Library',
      'evidence-library': 'Evidence Library',
    },
  },
  {
    parent: 'Digital Asset Intelligence',
    baseUrl: '/eciso/asset-dashboard',
    children: {
      'asset-dashboard': 'Asset Dashboard',
      'asset-inventory': 'Asset Inventory',
      'patch-intelligence': 'Patch Intelligence',
      'asset-risk-mapping': 'Asset-Risk Mapping',
    },
  },
  {
    parent: 'External Surface Management',
    baseUrl: '/eciso/domain-inventory',
    children: {
      'domain-inventory': 'Domain Inventory',
      'dns-ssl-monitoring': 'DNS & SSL Monitoring',
      'dmarc-security': 'DMARC / Email Security',
      'external-exposure': 'External Exposure View',
    },
  },
  {
    parent: 'Security Overview',
    baseUrl: '/eciso/integration-marketplace',
    children: {
      'security-landscape': 'Security Landscape',
      // 'integration-marketplace': 'Integration Marketplace',
      'connected-systems': 'Connected Systems',
      'data-pipelines': 'Data Pipelines',
      'api-access': 'API Access',
    },
  },
  {
    parent: 'Vulnerability & Threat Posture',
    baseUrl: '/eciso/vulnerability-dashboard',
    children: {
      'vulnerability-dashboard': 'Vulnerability Dashboard',
      'remediation-tracking': 'Remediation Tracking',
      'scanner-integrations': 'Scanner Integrations',
    },
  },
  {
    parent: 'Privacy & Data Protection',
    baseUrl: '/eciso/privacy-dashboard',
    children: {
      'privacy-dashboard': 'Privacy Dashboard',
      'consent-management': 'Consent Management',
      'data-mapping': 'Data Mapping',
      'dpia-risk-assessments': 'DPIA / Risk Assessments',
    },
  },
  {
    parent: 'Notification Center',
    baseUrl: '/eciso/notifications',
    children: {
      notifications: 'Inbox',
      'setting-notifications': 'Inbox',
      'notification-preferences': 'Notification Preferences',
    },
  },
  {
    parent: 'Settings',
    baseUrl: '/eciso/general-settings',
    children: {
      'general-settings': 'General Settings',
      'access-management': 'Access Management',
      'organization-setting': 'Organization Settings',
      employees: 'Employees',
      'my-profile': 'My Profile',
    },
  },
  {
    parent: 'Appearance',
    baseUrl: '/eciso/appearance',
    children: {
      branding: 'Company Branding',
    },
  },
  {
    parent: 'Applications',
    baseUrl: '/eciso/reorder',
    children: {
      reorder: 'Reorder App',
      personal: 'Personal App',
      appearance: 'Theme',
    },
  },
];
